import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeProduct } from 'slice/productSlice';
import { getCategory, updateCategory } from 'slice/categorySlice';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const CategoryList = () => {
    const dispatch = useDispatch();
    useSelector((state) => { console.log(state) });
    const cartData = useSelector((state) => state.category);
    const [showModal, setShowModal] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [imageFile, setImageFile] = useState(null);

    useEffect(() => {
        dispatch(getCategory());
    }, [dispatch]);

    const handleEditClick = (product) => {
        setCurrentProduct(product);
        setShowModal(true);
    };

    // Close the modal and reset state
    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
        setImageFile(null);
    };

    // Handle saving the edited product
    const handleSave = () => {
        const formData = new FormData();
        formData.append('id', currentProduct.id);
        formData.append('name', currentProduct.name);
        formData.append('description', currentProduct.description);
        formData.append('is_active', currentProduct.is_active);
        formData.append('price', currentProduct?.price);
        formData.append('actualPrice', currentProduct?.actualPrice);


        // If a new image is uploaded, append it to the formData
        if (imageFile) {
            formData.append('image', imageFile);
        }
        // Dispatch updateProduct with the formData
        dispatch(updateCategory({ id: currentProduct.id, data: formData }));
        toast('Category Updated Successfully!')
        handleCloseModal(); // Close modal after saving
    };

    const handleRemove = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeProduct(id));
                Swal.fire("Deleted!", "The product has been removed.", "success");
            }
        });
    };

    // Handle image file selection
    const handleImageChange = (event) => {
        setImageFile(event.target.files[0]);
    };

    // Table Headers
    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={`${process.env.REACT_APP_BACKEND}asserts/category/${row.original.images}`}
                    alt={row.original.name}
                    width={100}
                />
            ),
        },
        {
            Header: 'Service',
            accessor: 'service.name',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Price',
            accessor: 'price',
        },
        {
            Header: 'Created Date',
            accessor: 'createdAt',
        },
        {
            Header: 'Description',
            accessor: 'description',
            Cell: ({ row }) => <TruncatedMessage text={row.original.description} maxLength={30} />
        },
        {
            Header: 'Active',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={row.original.is_active ? 'badge badge-success' : 'badge badge-danger'}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button
                        className="btn removebtn mx-1 my-1"
                        onClick={() => handleRemove(row.original.id)}
                    >
                        Remove
                    </button>
                    <button
                        className="btn editbtn mx-1 my-1"
                        onClick={() => handleEditClick(row.original)}
                    >
                        Edit
                    </button>
                </>
            ),
        },
    ];

    return (
        <>
            <div className="container-fluid mt-5 ">
                <div className="mainheadig mx-4">
                    <h4 className="text-white font-weight-bold">Category List</h4>
                </div>
                {cartData?.data?.length > 0 && (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                )}
            </div>

            {/* Edit Modal */}
            {showModal && currentProduct && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="editModalLabel">Edit Category</h5>
                                <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="productName">Status</label>
                                        <select defaultValue={currentProduct.is_active} onChange={(e) => setCurrentProduct({ ...currentProduct, is_active: e.target.value })} className="form-control" id="productStatus">
                                            <option value={true}>Active</option>
                                            <option value={false}>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="productName">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="productName"
                                            value={currentProduct.name}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, name: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="PriceName">Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="PriceName"
                                            value={currentProduct.price}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, price: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="actualPriceName">Actual Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="actualPriceName"
                                            value={currentProduct.actualPrice}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, actualPrice: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="productDescription">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="productDescription"
                                            value={currentProduct.description}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, description: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="updateImage">Update Images</label>
                                        <input type='file' name='image' className='form-control' onChange={(e) => handleImageChange(e)} />
                                        {
                                            imageFile && (
                                                <img src={URL.createObjectURL(imageFile)} alt='product' className='img-fluid' />
                                            )
                                        }
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CategoryList;
